import { render, staticRenderFns } from "./FSelect.vue?vue&type=template&id=9638f374&"
import script from "./FSelect.vue?vue&type=script&lang=ts&"
export * from "./FSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports